<script setup lang="ts">
import { NxtInput, NxtFilepicker, NxtDropzone, NxtButton } from '@future-harry/nxt-styles';
import { ref } from 'vue';

const searchValue = defineModel<any>('searchValue', { required: true });

const emit = defineEmits<{
   (e: 'onFileAdded', file: File): void;
   (e: 'onSearch', query: string): void;
}>();

const filepickerRef = ref<typeof NxtFilepicker>();
const acceptedFiles = 'image/*,video/mp4';

const localFile = ref<File | undefined>(undefined);
watch(localFile, (newFile) => {
   if (newFile) {
      emit('onFileAdded', newFile);
   }
});

const handleUpload = () => {
   filepickerRef.value?.openFilePicker();
};
</script>

<template>
   <div class="media-library-actions">
      <NxtInput v-model="searchValue" :placeholder="$t('media-library.search-file')" :name="'media-library_search-file'" />
      <NxtFilepicker
         v-show="false"
         ref="filepickerRef"
         :placeholder="$t('media-library.upload')"
         :name="'media-library_upload-filepicker'"
         :accept="acceptedFiles"
         v-model="localFile"
      />
      <NxtButton @click="handleUpload">{{ $t('media-library.upload') }}</NxtButton>
   </div>
   <NxtDropzone
      :name="'media-library_upload-dropzone'"
      :accept="acceptedFiles"
      :placeholder="$t('media-library.upload-drop')"
      v-model="localFile"
   />
</template>

<style lang="scss" scoped>
.media-library-actions {
   margin: var(--nxt-gutter) 0;
   display: flex;
   align-items: center;
   justify-content: space-between;
}
</style>
